import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        // Redirect to login page if not authenticated
        navigate('/', { replace: true });
        return;
      }

      // Check if email is verified
      if (user && user.email_verified === false) {
        navigate('/unverified', { replace: true });
        return;
      }
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  // Show loading while Auth0 is determining authentication state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Authenticating...</div>
      </div>
    );
  }

  // Don't render anything while redirecting
  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Redirecting to login...</div>
      </div>
    );
  }

  // Check email verification
  if (user && user.email_verified === false) {
    return null; // Will be redirected by useEffect
  }

  // Render protected content
  return children;
};

export default ProtectedRoute; 